var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4999 4.46934V16.3651L15.5 16.3652C15.5 16.9009 15.2871 17.4143 14.9085 17.793C14.5297 18.1717 14.0162 18.3846 13.4806 18.3846H10.5961V16.6537H13.4806C13.5573 16.6537 13.6305 16.6233 13.6847 16.5692C13.7388 16.5151 13.7692 16.4418 13.7692 16.3652V5.69224H10.3077V2.23079H2.51936C2.36 2.23079 2.23082 2.35997 2.23082 2.51933V16.3653C2.23082 16.5247 2.36 16.6539 2.51936 16.6539H5.40394V18.3847H2.51936C1.9837 18.3847 1.47023 18.1719 1.09155 17.7932C0.712883 17.4145 0.5 16.901 0.5 16.3654V2.51936C0.5 1.98371 0.712862 1.47023 1.09155 1.09155C1.47025 0.712882 1.98376 0.5 2.51936 0.5H11.5306L15.4999 4.46934ZM8.86622 11.5293V18.3833H7.13536V11.5293L5.43913 13.2256L4.21617 12.0026L7.38931 8.82945C7.55148 8.66727 7.77141 8.57632 8.00079 8.57632C8.23017 8.57632 8.45009 8.66728 8.61227 8.82945L11.7854 12.0026L10.5625 13.2256L8.86622 11.5293Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.43f1f31a272191528cada88a2cd7d593.svg";
export { ForwardRef as ReactComponent };